import { useState, useEffect } from 'react';
import './insurance.scss';
import SVGInline from 'react-svg-inline';
import fetchData from '../../../../../../shared/services/fetchData';
import { ACCEPTED_INSURANCE_ENDPOINT } from '../../../../../../shared/constants/api-helpers';


const featuredCount=5
const Insurance = () => {
  const [showAll, setShowAll] = useState(false);
  const [acceptedInsurances, setAcceptedInsurances] = useState([]);

  useEffect(() => {
    async function fetchAcceptedInsurances() {
      try {
        const params = { endPoint: ACCEPTED_INSURANCE_ENDPOINT };
        const response = await fetchData(params);
        if (!response.success) {
          throw new Error(`HTTP error! status: ${response.success}`);
        }
        setAcceptedInsurances(response.results || []);
      } catch (error) {
        console.error('Error fetching accepted insurances:', error);
      }
    }
    fetchAcceptedInsurances();
  }, []);


  const insurancesToShow = showAll
    ? [...acceptedInsurances].sort((a, b) => a.localeCompare(b))
    : acceptedInsurances.slice(0, featuredCount);

  const toggleShowAll = () => {
    setShowAll(prev => !prev);
  };

  return (
    <div>
      <h4 className='provider-about-header'>Accepted Insurance</h4>
      <div className='provider-about-container'>
        <div className='insurance-list-container'>
          <div className='insurance-list'>
            {insurancesToShow.map((insurance, idx) => (
              <div key={idx} className='insurance-name'>{insurance}</div>
            ))}
          </div>
          <div className="show-all-btn-wrapper">
            {!showAll && (
              <a className="show-all-btn" href="#" onClick={e => { e.preventDefault(); toggleShowAll(); }}>
                Show All Accepted Insurance Plans
                <span className="dropdown-arrow" style={{ marginLeft: 3, verticalAlign: 'middle' }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 19 18" fill="none">
                    <path d="M6.0575 6.375L9.5 9.61994L12.9425 6.375L14 7.37399L9.5 11.625L5 7.37399L6.0575 6.375Z" fill="#0070AB"/>
                  </svg>
                </span>
              </a>
            )}
            {showAll && (
              <a className="show-all-btn" href="#" onClick={e => { e.preventDefault(); toggleShowAll(); }}>
                Show Less Accepted Insurance Plans
                <span className="dropdown-arrow" style={{ marginLeft: 3, verticalAlign: 'middle' }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 19 18" fill="none">
                    <path d="M6.0575 11.625L9.5 8.38006L12.9425 11.625L14 10.626L9.5 6.375L5 10.626L6.0575 11.625Z" fill="#0070AB"/>
                  </svg>
                </span>
              </a>
            )}
          </div>
        </div>
        <div className="insurance-help-text">
          Every effort has been made to offer the most current and correct information possible on this website. Nevertheless, inadvertent errors regarding information may occur and OhioHealth/Managed Care disclaims any responsibility and makes no representations regarding the quality, content, completeness, accuracy and/or timeliness of information and data herein. Further, information and data on this website are subject to change at any time.
        </div>
      </div>
      <div className='flex justify-center'>
        <div className='drawer-divider' />
      </div>
    </div>
  );
};

export default Insurance;